module.exports = __webpack_public_path__ + "static/media/alert-light.43967eaf.svg";